import { Session } from '@kaizenplatform/hugot-entity';

const STORAGE_KEY = 'YWxpYmFiYS13ZWI6c2Vzc2lvbkAx';

class SessionStorage {
  private storage: Storage;

  constructor({ storage }: { storage: Storage }) {
    this.storage = storage;
  }

  public getSession(): Session | null {
    const jsonString = this.storage.getItem(STORAGE_KEY);

    if (!jsonString) return null;

    const json = JSON.parse(jsonString);

    const authenticationToken = json['authenticationToken'];
    const refreshToken = json['refreshToken'];

    return Session.fromJSON({ authenticationToken, refreshToken });
  }

  public writeSession(session: Session): void {
    const jsonString = JSON.stringify({
      authenticationToken: session.authenticationToken,
      refreshToken: session.refreshToken,
    });

    this.storage.setItem(STORAGE_KEY, jsonString);
  }

  public deleteSession(): void {
    this.storage.removeItem(STORAGE_KEY);
  }
}

export default SessionStorage;
